import searchState from './SearchStateActions';
import currentUser from './UserActions';


const allActions = {
    searchState,
    currentUser
}

export default allActions;